// UC Brand Accessible Color Guide for Charts
const CATEGORY_COLORS = {
  'Light Duty Vehicles': '#1295D8',    // UC Blue - Primary
  'Heavy Duty Vehicles': '#FFB511',    // UC Gold - Primary
  'Electricity - Residential': '#00778B', // UC Teal
  'Electricity - Commercial': '#FF6E1B',  // UC Orange
  'Natural Gas - Residential': '#005581', // UC Dark Blue
  'Natural Gas - Commercial': '#E44C9A',  // UC Pink
  'Offroad': '#FFD200',                // UC Gold
  'Waste & Wastewater': '#7C7E7F',     // UC Gray
  'Agriculture': '#00A3AD'             // UC Light Teal
};

const FALLBACK_PALETTE = [
  '#1295D8', '#FFB511', '#00778B', '#FF6E1B', '#005581',
  '#E44C9A', '#FFD200', '#7C7E7F', '#00A3AD', '#72CDF4'
];

export function getCategoryColor(category, index = 0) {
  return CATEGORY_COLORS[category] || FALLBACK_PALETTE[index % FALLBACK_PALETTE.length];
}

export function getColorsForCategories(categories) {
  return categories.map((c, i) => getCategoryColor(c, i));
}

export default CATEGORY_COLORS;


